export default __webpack_public_path__ + "static/media/Step-8-safari.8c664e49.mov";